import { RouteConfig } from 'vue-router'
import _ from 'lodash'
import { Feature, MemberType } from '@/types/generated/graphql'

// TODO : 契約ごとの認可チェック

const routes: Array<RouteConfig> = [
  {
    path: '/services',
    name: 'Services',
    component: () =>
      import(
        /* webpackChunkName: "services" */ '@/views/PartnerServiceContractList.vue'
      ),
    meta: { title: 'services.title', memberType: MemberType.Individual },
    alias: '/',
  },
  {
    path: '/services/:id',
    name: 'ServiceHome',
    component: () =>
      import(/* webpackChunkName: "service-home" */ '@/views/ServiceHome.vue'),
    meta: { title: 'serviceHome.title', memberType: MemberType.Individual },
  },
  {
    path: '/services/agent-sales/documents',
    name: 'AgentSalesDocuments',
    component: () =>
      import(
        /* webpackChunkName: "agent-sales-documents" */ '@/views/AgentSalesDocuments.vue'
      ),
    meta: {
      title: 'agentSalesDocuments.title',
      memberType: MemberType.StoreOwner,
    },
  },
  {
    path: '/verify',
    name: 'Verify',
    component: () =>
      import(/* webpackChunkName: "verify" */ '@/views/Verify.vue'),
    meta: { title: 'verify.title', layout: 'default' },
  },
  {
    path: '/password/edit',
    name: 'UpdatePassword',
    component: () =>
      import(
        /* webpackChunkName: "password-edit" */ '@/views/UpdatePassword.vue'
      ),
    meta: { title: 'updatepassword.title' },
  },
  {
    path: '/partner',
    name: 'Partner',
    component: () =>
      import(/* webpackChunkName: "partner" */ '@/views/Partner.vue'),
    meta: { title: 'partner.title', memberType: MemberType.StoreOwner },
  },
  {
    path: '/partner/:partnerId',
    name: 'PartnerInfo',
    component: () =>
      import(/* webpackChunkName: "partnerInfo" */ '@/views/PartnerInfo.vue'),
    meta: { title: 'partner.title', memberType: MemberType.Owner },
  },
  {
    path: '/account',
    name: 'Account',
    component: () =>
      import(/* webpackChunkName: "account" */ '@/views/Account.vue'),
    meta: { title: 'account.title' },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () =>
      import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
    meta: { title: 'profile.title' },
  },
  {
    path: '/profile/edit',
    name: 'ProfileEdit',
    component: () =>
      import(/* webpackChunkName: "profile-edit" */ '@/views/ProfileEdit.vue'),
    meta: { title: 'profile.title' },
  },
  {
    path: '/card',
    name: 'CreditCard',
    component: () =>
      import(/* webpackChunkName: "card" */ '@/views/CreditCard.vue'),
    meta: { title: 'creditcard.title' },
  },
  {
    path: '/addresses',
    name: 'ShippingAddressList',
    component: () =>
      import(
        /* webpackChunkName: "shippingAddressList" */ '@/views/ShippingAddressList.vue'
      ),
    meta: { title: 'shippingAddresses.title' },
  },
  {
    path: '/addresses/create',
    name: 'ShippingAddressCreate',
    component: () =>
      import(
        /* webpackChunkName: "shippingAddressCreate" */ '@/views/ShippingAddressCreate.vue'
      ),
    meta: { title: 'shippingAddressCreate.title' },
  },
  {
    path: '/addresses/:id/edit',
    name: 'ShippingAddressEdit',
    component: () =>
      import(
        /* webpackChunkName: "shippingAddressEdit" */ '@/views/ShippingAddressEdit.vue'
      ),
    meta: { title: 'shippingAddressEdit.title' },
  },
  {
    path: '/partner/:partnerId/addresses',
    name: 'PartnerShippingAddressList',
    component: () =>
      import(
        /* webpackChunkName: "PartnerShippingAddressList" */ '@/views/PartnerShippingAddressList.vue'
      ),
    meta: {
      title: 'partnerShippingAddressList.title',
      memberType: MemberType.StoreOwner,
    },
  },
  {
    path: '/partner/:partnerId/addresses/create',
    name: 'PartnerShippingAddressCreate',
    component: () =>
      import(
        /* webpackChunkName: "PartnerShippingAddressCreate" */ '@/views/PartnerShippingAddressCreate.vue'
      ),
    meta: {
      title: 'partnerShippingAddressCreate.title',
      memberType: MemberType.StoreOwner,
    },
  },
  {
    path: '/partner/:partnerId/addresses/:id/edit',
    name: 'PartnerShippingAddressEdit',
    component: () =>
      import(
        /* webpackChunkName: "partnerShippingAddressEdit" */ '@/views/PartnerShippingAddressEdit.vue'
      ),
    meta: {
      title: 'partnerShippingAddressEdit.title',
      memberType: MemberType.StoreOwner,
    },
  },
  {
    path: '/partner/:partnerId/agent/destinations',
    name: 'PartnerAgentDestinationList',
    component: () =>
      import(
        /* webpackChunkName: "PartnerAgentDestinationList" */ '@/views/PartnerAgentDestinationList.vue'
      ),
    meta: {
      title: 'partnerAgentDestinationList.title',
      memberType: MemberType.StoreOwner,
    },
  },
  {
    path: '/partner/:partnerId/agent/destinations/create',
    name: 'PartnerAgentDestinationCreate',
    component: () =>
      import(
        /* webpackChunkName: "PartnerAgentDestinationCreate" */ '@/views/PartnerAgentDestinationCreate.vue'
      ),
    meta: {
      title: 'partnerAgentDestinationCreate.title',
      memberType: MemberType.StoreOwner,
    },
  },
  {
    path: '/partner/:partnerId/agent/destinations/:id/edit',
    name: 'PartnerAgentDestinationEdit',
    component: () =>
      import(
        /* webpackChunkName: "PartnerAgentDestinationEdit" */ '@/views/PartnerAgentDestinationEdit.vue'
      ),
    meta: {
      title: 'partnerAgentDestinationEdit.title',
      memberType: MemberType.StoreOwner,
    },
  },
  {
    path: '/partner/:partnerId/owners',
    name: 'PartnerStoreOwnerList',
    component: () =>
      import(
        /* webpackChunkName: "PartnerStoreOwnerList" */ '@/views/PartnerStoreOwnerList.vue'
      ),
    meta: {
      title: 'partnerStoreOwnerList.title',
      memberType: MemberType.StoreOwner,
    },
  },
  {
    path: '/partner/:partnerId/owners/:userId',
    name: 'PartnerStoreOwnerDetail',
    component: () =>
      import(
        /* webpackChunkName: "PartnerStoreOwnerDetail" */ '@/views/PartnerStoreOwnerDetail.vue'
      ),
    meta: {
      title: 'partnerStoreOwnerDetail.title',
      memberType: MemberType.Owner,
    },
  },
  {
    path: '/partner/:partnerId/bankaccounts',
    name: 'PartnerBankAccountList',
    component: () =>
      import(
        /* webpackChunkName: "PartnerBankAccountList" */ '@/views/PartnerBankAccountList.vue'
      ),
    meta: {
      title: 'partnerBankAccountList.title',
      memberType: MemberType.StoreOwner,
      feature: Feature.BankAccount,
    },
  },
  {
    path: '/partner/:partnerId/bankaccounts/create',
    name: 'PartnerBankAccountCreate',
    component: () =>
      import(
        /* webpackChunkName: "PartnerBankAccountCreate" */ '@/views/PartnerBankAccountCreate.vue'
      ),
    meta: {
      title: 'partnerBankAccountCreate.title',
      memberType: MemberType.Owner,
      feature: Feature.BankAccount,
    },
  },
  {
    path: '/partner/:partnerId/bankaccounts/edit',
    name: 'PartnerBankAccountEdit',
    component: () =>
      import(
        /* webpackChunkName: "PartnerBankAccountEdit" */ '@/views/PartnerBankAccountEdit.vue'
      ),
    meta: {
      title: 'partnerBankAccountEdit.title',
      memberType: MemberType.Owner,
      feature: Feature.BankAccount,
    },
  },
  {
    path: '/partner/:partnerId/bankaccounts/store/:storeId/create',
    name: 'StoreBankAccountCreate',
    component: () =>
      import(
        /* webpackChunkName: "StoreBankAccountCreate" */ '@/views/StoreBankAccountCreate.vue'
      ),
    meta: {
      title: 'storeBankAccountCreate.title',
      memberType: MemberType.StoreOwner,
      feature: Feature.BankAccount,
    },
  },
  {
    path: '/partner/:partnerId/bankaccounts/store/:storeId/edit',
    name: 'StoreBankAccountEdit',
    component: () =>
      import(
        /* webpackChunkName: "StoreBankAccountEdit" */ '@/views/StoreBankAccountEdit.vue'
      ),
    meta: {
      title: 'storeBankAccountEdit.title',
      memberType: MemberType.StoreOwner,
      feature: Feature.BankAccount,
    },
  },
  {
    path: '/ffgoods/:id/:fulfillmentProcessId',
    name: 'FfGoodsDetail',
    component: () =>
      import(/* webpackChunkName: "FfGoods" */ '@/views/FfGoodsDetail.vue'),
    meta: { title: 'ffGoodsDetail.title' },
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () =>
      import(/* webpackChunkName: "Orders" */ '@/views/OrderHistory.vue'),
    meta: { title: 'orderHistory.title' },
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    component: () =>
      import(
        /* webpackChunkName: "Subscriptions" */ '@/views/SubscriptionList.vue'
      ),
    meta: { title: 'subscriptionList.title' },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () =>
      import(/* webpackChunkName: "Contact" */ '@/views/Contact.vue'),
    meta: { title: 'contact.title' },
  },
  {
    path: '/contact/complete',
    name: 'ContactComplete',
    component: () =>
      import(
        /* webpackChunkName: "ContactComplete" */ '@/views/ContactComplete.vue'
      ),
    meta: { title: 'contactComplete.title' },
  },
  {
    path: '/affiliate/:partnerId/stores',
    name: 'AffiliateStores',
    component: () =>
      import(
        /* webpackChunkName: "affiliateStores" */ '@/views/AffiliateStores.vue'
      ),
    meta: {
      title: 'affiliate.title',
      memberType: MemberType.StoreOwner,
      feature: Feature.Affiliate,
    },
  },
  {
    path: '/affiliate/:partnerId/total',
    name: 'TotalAffiliate',
    component: () =>
      import(
        /* webpackChunkName: "TotalAffiliate" */ '@/views/TotalAffiliate.vue'
      ),
    meta: {
      title: 'affiliate.title',
      memberType: MemberType.Owner,
      feature: Feature.Affiliate,
    },
  },
  {
    path: '/affiliate/:partnerId/:storeId',
    name: 'Affiliate',
    component: () =>
      import(/* webpackChunkName: "affiliate" */ '@/views/Affiliate.vue'),
    meta: {
      title: 'affiliate.title',
      memberType: MemberType.StoreOwner,
      feature: Feature.Affiliate,
    },
  },
  {
    path: '/notfound',
    name: 'NotFound',
    component: () =>
      import(/* webpackChunkName: "notfound" */ '@/views/NotFound.vue'),
    meta: { title: 'notFound.title' },
  },
]

export default routes.map((route) => {
  return _.merge({ meta: { private: true, layout: 'private' } }, route)
})
